import { useNavigate } from "react-router-dom";

interface Props {
  title: string;
  backTo?: string;
}

export default function AppHeader({ title, backTo }: Props) {
  const navigate = useNavigate();
  return (
    <header className="app-header">
      {backTo ? (
        <button
          className="app-header__back"
          aria-label="Back"
          onClick={() => navigate(backTo)}
        >
          &#8592;
        </button>
      ) : (
        <span />
      )}
      <h1 className="app-header__title">{title}</h1>
      <span />
    </header>
  );
}
